<template>
    <div class="empty-content">
        <div class="empty-box">
            <div>
                <img src="../../assets/img/empty.png" alt="">
            </div>
            <div>正在加速开发中，敬请期待...</div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'WaitingDevelop',
    props: {
        msg: String
    },
    data() {
        return {

        };
    },
    methods: {

    },
    mounted: function() {
        this.sessionData('set','channelItem','在线客服');
    },
}
</script>
<style scoped  lang="less">
    .empty-content{
        width: 100%;
        height: 100%;
        position: relative;
        .empty-box{
            top: 50%;
            left: 50%;
            transform: translate(-50%,-70%);
            position: absolute;
        }
        img{
            width: 200px;
            margin-bottom:24px;
        }
        color: rgba(80, 80, 80, 1);
        font-size: 16px;
        text-align: center;
    }
</style>
